export default __webpack_public_path__ + "static/media/awesome.5a502111.svg";